import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EntityTypeConfigKeys } from '@utils/entityViewConfig';
import { PAGE_PATHS } from '../../../../../../types';

const path = PAGE_PATHS.ALERTS;
export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/detections/alerts/{-$id}/')({
  staticData: {
    path,
    key: EntityTypeConfigKeys.Alert,
  },
  validateSearch: zodValidator(withDefaults(schema.ALERTS, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
});
